// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1ON7p","inputWrap":"CustomTip_inputWrap__2mEhu"};